module.exports = __webpack_public_path__ + "static/img/mainbusiness04.e57dc7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/01/mainbusiness04.png
// module id = fqnT
// module chunks = 1